import { FC } from "react";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import styles from "./NewNetworkPage.module.scss";
import { NewNetworkForm } from "../../components/Account/Update/tabComponents/PaymentRemittance/NewNetworkForm";


export const NewNetworkPage: FC = () => {

  return (
    <div className={styles.NewNetworkContainer}>
      <Stack spacing="large">
        <NewNetworkForm />
      </Stack>
    </div>
  );
};

export default NewNetworkPage;
